<template>
    <div>
        <hero-bar :has-right-visible="true" menu-icon="desktop-mac">
            {{ $lang.Calculation.Title }}
            <span class="subtitle hero-subtitle">{{ pageTitle }}</span>

            <p class="control" v-if="isCircDeviceDemandActive" slot="right" style="margin-right: 16px">
                <b-button class="button is-catalog-request" icon-left="plus-box-outline" @click="openCircuitDevices">{{ catalogRequestLabel }}</b-button>
            </p>
            <p class="control" slot="right" style="margin-right: 16px">
                <b-button class="button is-gray" @click="previous">{{ $lang.Menus.BackBtn }}</b-button>
            </p>
            <p class="control" slot="right">
                <b-button v-if="isSecondTabActive && !isLostPowerCalculated && (activeTab == 0 || activeTab == 2)" class="button is-primary" @click="calculateLostPower_CurrentPanel">{{ $lang.PanelInfos.CalculateBtn }}</b-button>
                <b-button v-else-if="!isSecondTabActive && !isLostPowerCalculated && activeTab == 0" class="button is-primary" @click="calculateLostPower_CurrentPanel">{{ $lang.PanelInfos.CalculateBtn }}</b-button>
                <b-button v-else class="button is-primary" @click="submit">{{ $lang.Menus.ContinueBtn }}</b-button>
            </p>
        </hero-bar>

        <div class="wizard">
            <div class="wizard-rail">
                <verticalStep-bar />
            </div>

            <div class="wizard-body calc-body">
                <calc-method-cards :active="activeMethod" :show-measured="isSecondTabActive" @select="selectMethod" />

                <!-- Known total power loss -->
                <div v-if="activeTab == 0" class="wizard-card calc-method-panel">
                    <b-field :type="{ 'is-danger': hasError_totalLostpower }" :message="emptyWarning_totalLostpower">
                        <template #label>{{ label_totalLostpower }}</template>
                        <div class="unit-control">
                            <b-numberinput v-model="totalLostpower" class="unit-input is-wide" min="1" :controls="false" step="any" @input="setTotalLostPowerValidity"></b-numberinput>
                            <span class="unit">W</span>
                        </div>
                    </b-field>
                </div>

                <!-- Measured temperature (up to 630 A): two readings, the loss worked out from them -->
                <div v-if="isSecondTabActive && activeTab == 2" class="calc-measured">
                    <div class="wizard-card calc-method-panel">
                        <b-field :type="{ 'is-danger': hasError_paneltemperature }" :message="emptyWarning_paneltemperature">
                            <template #label>{{ label_paneltemperature }}</template>
                            <div class="unit-control">
                                <b-input v-model="paneltemperature" class="unit-input" type="number" step="any" @input="setLostPowerCalculated()"></b-input>
                                <span class="unit">°C</span>
                            </div>
                        </b-field>
                        <b-field :type="{ 'is-danger': hasError_envtemperature }" :message="emptyWarning_envtemperature">
                            <template #label>{{ label_envtemperature }}</template>
                            <div class="unit-control">
                                <b-input v-model="envtemperature" class="unit-input" type="number" step="any" @input="setLostPowerCalculated()"></b-input>
                                <span class="unit">°C</span>
                            </div>
                        </b-field>
                    </div>
                    <div class="fan-result">
                        <p class="fan-result-label">{{ label_P_total_panel }}</p>
                        <p class="fan-result-value">{{ truncate(totalLostpower_2, 1) }} <span class="fan-result-unit">W</span></p>
                    </div>
                </div>

                <!-- The calculation tool: its five parts, and what has been added so far -->
                <template v-if="activeTab == toolTab">
                    <outputCircBtns />

                    <p class="wizard-card-head">{{ label_calculatedTitle }}</p>
                    <div class="calc-table-card">
                        <b-table class="data-table is-flush" :data="devicesdata">
                            <b-table-column field="Definition" :label="label_tableDefinition" v-slot="props" cell-class="cell-strong">
                                {{ props.row.Definition }}
                            </b-table-column>
                            <b-table-column field="LostPower" width="180" numeric>
                                <template v-slot:header="">
                                    <span v-html="$lang.Calculation.TableLostPower"></span>
                                </template>
                                <template v-slot="props">
                                    {{ truncate(parseFloat(props.row.LostPower), 1) }}
                                </template>
                            </b-table-column>
                            <b-table-column field="Action" v-slot="props" width="76">
                                <div class="row-actions">
                                    <button class="button row-action" :title="$lang.MyProjects.Edit" @click="updateCalculationData(props.row)">
                                        <span class="mdi mdi-pencil" aria-hidden="true"></span>
                                    </button>
                                </div>
                            </b-table-column>
                            <template #empty>
                                <p class="table-empty">{{ $lang.Calculation.CalculationWarning_2 }}</p>
                            </template>
                        </b-table>
                        <div class="calc-total">
                            <span>{{ label_totalP }}</span>
                            <b>{{ truncate(parseFloat(totalLostpower_3), 1) }}</b>
                        </div>
                    </div>
                </template>
            </div>
        </div>

        <!-- Changing the method discards what the current one holds, so it asks first. -->
        <b-modal v-model="isTabsModalActive" has-modal-card :can-cancel="false">
            <div class="modal-card calc-confirm">
                <section class="modal-card-body">
                    <p>{{ $lang.Calculation.CalculationWarning }}</p>
                </section>
                <footer class="modal-card-foot">
                    <b-button :label="$lang.Calculation.MethodChangeCancel" @click="cancelTabChange()" />
                    <b-button :label="$lang.Calculation.MethodChangeConfirm" type="is-danger" @click="approveTabChange()" />
                </footer>
            </div>
        </b-modal>

        <!-- Devam with nothing added to the tool. The flag was set, but no dialog showed it. -->
        <b-modal v-model="isCalcWarningModalActive" has-modal-card>
            <div class="modal-card calc-confirm">
                <section class="modal-card-body">
                    <p>{{ $lang.Calculation.CalculationWarning_2 }}</p>
                </section>
                <footer class="modal-card-foot">
                    <b-button :label="$lang.Menus.Okay" type="is-primary" @click="isCalcWarningModalActive = false" />
                </footer>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import router from '@/router';
    import api from '@/api';
    import VerticalStepBar from '@/components/VerticalStepBar.vue';
    import OutputCircBtns from '@/components/OutputCircBtns.vue';
    import CalcMethodCards from '@/components/CalcMethodCards.vue';
    import { fetchLossTotals, storeLossTotals } from '@/api/lossTotals';

    export default {
        name: 'Calculation',
        components: {
            VerticalStepBar,
            OutputCircBtns,
            CalcMethodCards
        },
        data() {
            return {
                isActive: true,
                projectId: 0,
                pageTitle: '',
                isCircDeviceDemandActive: false,
                // activeTab keeps the old tab numbering: 0 known, 2 measured (up to 630 A),
                // toolTab for the tool - 4 when "measured" is offered, 2 when it is not.
                activeTab: 0,
                pendingTab: null,
                pendingMethod: null,
                isSecondTabActive: false,
                isTabsModalActive: false,
                areHiddenStepsVisible: false,
                canGoNextPage: false,

                totalLostpower: 0,
                hasError_totalLostpower: false,
                emptyWarning_totalLostpower: '',

                paneltemperature: 0,
                envtemperature: 0,
                totalLostpower_2: 0,
                isLostPowerCalculated: false,
                hasError_paneltemperature: false,
                emptyWarning_paneltemperature: '',
                hasError_envtemperature: false,
                emptyWarning_envtemperature: '',

                devicesdata: [],
                totalLostpower_3: 0,
                isCalcWarningModalActive: false,

                label_totalLostpower: this.$lang.Calculation.TotalLostPower_1,
                label_paneltemperature: this.$lang.Calculation.PanelTemp,
                label_envtemperature: this.$lang.Calculation.EnvTemp,
                label_P_total_panel: this.$lang.Calculation.LostPower_InPanel,
                label_calculatedTitle: this.$lang.Calculation.Label_1,
                label_totalP: this.$lang.Calculation.TotalLostPower_2,
                label_tableDefinition: this.$lang.Calculation.TableDefinition,
            }
        },
        computed: {
            toolTab() {
                return this.isSecondTabActive ? 4 : 2;
            },
            // The card that is lit: 0 known, 1 measured, 2 tool.
            activeMethod() {
                if (this.activeTab == this.toolTab) return 2;
                return this.activeTab == 0 ? 0 : 1;
            },
            catalogRequestLabel() {
                const c = this.$lang.Calculation;
                return [c.InnerTitle_14, c.InnerTitle_15, c.InnerTitle_16].filter((p) => p).join(' ');
            }
        },
        beforeMount() {
            if (this.$store.state.ratedCurrentIndex == 1) {
                this.isSecondTabActive = true;
            } else {
                this.isSecondTabActive = false;
            }
        },
        mounted() {
            this.projectId = this.$store.state.projectId;

            if (this.$store.state.ratedCurrentIndex == 1) {
                this.activeTab = 2 * this.$store.state.calcIndex - 2;
            } else {
                if (this.$store.state.calcIndex == 3) {
                    this.activeTab = 2;
                } else {
                    this.activeTab = this.$store.state.calcIndex - 1;
                }
            }

            this.setPageTitle(this.activeTab);
            this.totalLostpower = this.$store.state.totalLostPower_1;
            this.paneltemperature = this.$store.state.inPanelTemperature;
            this.envtemperature = this.$store.state.envMeasureTemperature;
            this.totalLostpower_2 = this.$store.state.totalLostPower_2;
            this.calculateLostPower_CurrentPanel();

            this.getCalculationDatas();
            this.$store.state.activeStep = 3;

            // A method card picked on one of the tool's screens: ask here, as for a card on
            // this page.
            if (this.$store.state.calcIndexFromOutputCircs != -1) {
                this.selectMethod(this.$store.state.calcIndexFromOutputCircs);
            }

            this.$store.state.isFooterFixed = true;
        },
        methods: {
            previous() {
                this.$store.isPageOpenedFromStepBar = false;

                router.push('/envConditions');
            },
            submit() {
                this.controlInputs();

                if (this.canGoNextPage) {
                    this.totalLostpower = this.truncate(this.totalLostpower, 1);

                    var payload = {
                        totalLostPower_1: this.totalLostpower
                    };
                    this.$store.commit('setCalculationDatas', payload);

                    this.calculateLostPower_CurrentPanel();
                    var payload2 = {
                        inPanelTemperature: this.paneltemperature, envMeasureTemperature: this.envtemperature, totalLostPower_2: this.totalLostpower_2
                    };
                    this.$store.commit('setCalculationDatas_2', payload2);

                    this.$store.isPageOpenedFromStepBar = false;
                    this.$store.canResultOpen = true;
                    this.$store.state.calcIndexFromOutputCircs = -1;

                    const go = () => {
                        if (this.$store.state.memberId == 'TestMember') {
                            router.push('/LoginMember');
                        } else {
                            this.$store.state.isCompleted = true;
                            router.push('/results');
                        }
                    };

                    if (this.activeTab == this.toolTab) {
                        // The tool's total, from the server (api/lossTotals.js). This page used
                        // to write its own sum, which left out the output circuits' count.
                        storeLossTotals(this.$store, this.projectId).then(go).catch(() => {
                            this.$buefy.dialog.alert(this.$errorModal({}));
                        });
                    } else {
                        var payload3 = { totalLostPower_3: this.totalLostpower_3 };
                        this.$store.commit('setCalculationDatas_3', payload3);
                        go();
                    }
                }
            },
            setTotalLostPowerValidity() {
                if (this.totalLostpower < 1) {
                    this.totalLostpower = 1;
                }
            },
            setLostPowerCalculated() {
                this.isLostPowerCalculated = false;
            },
            setPageTitle(tabIndex) {
                if (tabIndex == 0) {
                    this.pageTitle = this.$lang.Calculation.NewTitle_1;
                    this.isCircDeviceDemandActive = false;
                } else if (tabIndex == 2) {
                    if (this.isSecondTabActive) {
                        this.pageTitle = this.$lang.Calculation.NewTitle_2;
                        this.isCircDeviceDemandActive = false;
                    } else {
                        this.pageTitle = this.$lang.Calculation.NewTitle_3;
                        this.isCircDeviceDemandActive = true;
                    }
                } else if (tabIndex == 4) {
                    if (this.isSecondTabActive) {
                        this.pageTitle = this.$lang.Calculation.NewTitle_3;
                        this.isCircDeviceDemandActive = true;
                    }
                }
            },
            // method: 0 known, 1 measured, 2 tool. Asks before switching; nothing changes until
            // the answer.
            selectMethod(method) {
                var target = method == 0 ? 0 : (method == 2 ? this.toolTab : 2);
                if (target == this.activeTab) {
                    this.$store.state.calcIndexFromOutputCircs = -1;
                    return;
                }
                this.pendingTab = target;
                this.pendingMethod = method;
                this.isTabsModalActive = true;
            },
            cancelTabChange() {
                this.pendingTab = null;
                this.pendingMethod = null;
                this.isTabsModalActive = false;

                // Picked on one of the tool's screens: go back to it.
                if (this.$store.state.calcIndexFromOutputCircs != -1) {
                    this.$store.state.calcIndexFromOutputCircs = -1;
                    router.push('/' + this.$store.state.currentRouteFromOutputCircs);
                }
            },
            approveTabChange() {
                this.activeTab = this.pendingTab;
                var method = this.pendingMethod;
                this.pendingTab = null;
                this.pendingMethod = null;
                this.$store.state.calcIndexFromOutputCircs = -1;

                this.setPageTitle(this.activeTab);
                // calcIndex: 1 known, 2 measured, 3 tool
                this.$store.state.calcIndex = method + 1;

                this.resetCalc_1();
                this.resetCalc_2();
                this.resetCalc_3();
                this.devicesdata = [];
                this.isTabsModalActive = false;

                if (method == 2) {
                    router.push('/calc_Busbar');
                }
            },
            resetCalc_1() {
                var payload1 = { totalLostPower_1: 0 };
                this.$store.commit('setCalculationDatas', payload1);

                this.totalLostpower = 0;
            },
            resetCalc_2() {
                var payload2 = { inPanelTemperature: 0, envMeasureTemperature: 0, totalLostPower_2: 0 };
                this.$store.commit('setCalculationDatas_2', payload2);

                this.totalLostpower_2 = 0;
            },
            resetCalc_3() {
                var payload3 = { InputCircuitDef: "", P_InputCircuit: 0, totalLostPower_3: 0 };
                this.$store.commit('set_Datas_InputCircuits', payload3);

                var payload4 = { OutputCircuitDef: "", P_OutputCircuit: 0, totalLostPower_3: 0 };
                this.$store.commit('set_Datas_OutputCircuits', payload4);

                var payload5 = { ManuelCircuitDef: "", P_ManuelCircuit: 0, totalLostPower_3: 0 };
                this.$store.commit('set_Datas_ManuelCircuits', payload5);

                var payload6 = { ManuelCircuitDef: "", P_Busbar: 0, totalLostPower_3: 0 };
                this.$store.commit('set_Datas_Busbar', payload6);

                api.panels.deleteFromCalcTables_1(this.projectId).then((res) => {
                    if (res.isError) {
                        console.log("error ");
                    }
                });
                api.panels.deleteFromCalcTables_2(this.projectId).then((res) => {
                    if (res.isError) {
                        console.log("error ");
                    }
                });
                api.panels.deleteFromCalcTables_3(this.projectId).then((res) => {
                    if (res.isError) {
                        console.log("error ");
                    }
                });
                api.panels.deleteFromCalcTables_4(this.projectId).then((res) => {
                    if (res.isError) {
                        console.log("error ");
                    }
                });
                api.panels.deleteFromCalcTables_5(this.projectId).then((res) => {
                    if (res.isError) {
                        console.log("error ");
                    }
                });
                api.panels.deleteFromCalcTables_6(this.projectId).then((res) => {
                    if (res.isError) {
                        console.log("error ");
                    }
                });
                api.panels.deleteFromCalcTables_7(this.projectId).then((res) => {
                    if (res.isError) {
                        console.log("error ");
                    }
                });

                this.totalLostpower_3 = 0;
            },
            controlInputs() {
                if (this.activeTab == 0) {
                    if (this.totalLostpower == 0) {
                        this.hasError_totalLostpower = true;
                        this.emptyWarning_totalLostpower = this.$lang.Menus.EmptyWarning;
                    } else {
                        this.canGoNextPage = true;
                        this.emptyWarning_totalLostpower = '';
                    }

                    if (this.totalLostpower != 0) {
                        this.hasError_totalLostpower = false;
                        this.emptyWarning_totalLostpower = '';
                    }
                } else if (this.activeTab == 2) {
                    if (!this.isSecondTabActive) {
                        if (this.devicesdata.length > 0) {
                            this.canGoNextPage = true;
                        } else {
                            this.isCalcWarningModalActive = true;
                        }
                    } else {
                        if (this.paneltemperature == 0) {
                            this.hasError_paneltemperature = true;
                            this.emptyWarning_paneltemperature = this.$lang.Menus.EmptyWarning;
                        } else if (this.envtemperature == 0) {
                            this.hasError_envtemperature = true;
                            this.emptyWarning_envtemperature = this.$lang.Menus.EmptyWarning;
                        } else {
                            this.canGoNextPage = true;
                        }

                        if (this.paneltemperature != 0) {
                            this.hasError_paneltemperature = false;
                            this.emptyWarning_paneltemperature = '';
                        }
                        if (this.envtemperature != 0) {
                            this.hasError_envtemperature = false;
                            this.emptyWarning_envtemperature = '';
                        }
                    }
                } else if (this.activeTab == 4) {
                    if (this.devicesdata.length > 0) {
                        this.canGoNextPage = true;
                    } else {
                        this.isCalcWarningModalActive = true;
                    }
                }
            },
            // What the tool holds, one row per busbar, one for the input circuit, one per output
            // circuit and one per additional power, and the total. The rows used to be built by
            // a chain that listed output circuits by their sub-distribution busbars (a circuit
            // without one was missing), gave busbar rows the input circuit's edit, and summed a
            // total without the circuits' count.
            getCalculationDatas() {
                const pid = this.projectId;
                const list = (res) => {
                    if (!res || res.isError) throw res || new Error('No answer');
                    return res.data || [];
                };
                const num = (v) => parseFloat(v) || 0;

                Promise.all([
                    api.panels.getBusbarCalculationDevices(pid),
                    api.panels.getInputCircuitCalcDevices(pid),
                    api.panels.getInputCircuitDeviceConductors(pid),
                    api.panels.getOutputCircuitCalcDevices_Detailed(pid),
                    api.panels.getOutputCircuitDeviceConductors_Detailed(pid),
                    api.panels.get_OutputCircuit_SubDistributionBusbars_Detailed(pid),
                    api.panels.getManuelCalcDevices(pid),
                    fetchLossTotals(pid)
                ]).then(([busbars, inputDevices, inputConductors, outDevices, outConductors, outBusbars, manuel, totals]) => {
                    const rows = [];

                    list(busbars).forEach((e) => rows.push({ Id: 3, Definition: e.Definition, LostPower: num(e.CalcResult) }));

                    const inDevices = list(inputDevices);
                    const inConductors = list(inputConductors);
                    if (inDevices.length || inConductors.length) {
                        const p = inDevices.reduce((t, e) => t + num(e.Pv != null ? e.Pv : e.CalcResult), 0) +
                            inConductors.reduce((t, e) => t + num(e.CalcResult), 0);
                        rows.push({ Id: 0, Definition: this.$lang.Calculation.NewTitle_5, LostPower: p });
                    }

                    // Output circuits by CircuitIndex: (devices + conductors) x count + sub-distribution
                    // busbar - the server's own total for them.
                    const circuits = new Map();
                    const add = (res, key) => list(res).forEach((c) => {
                        const entry = circuits.get(c.CircuitIndex) || { Definition: c.Definition, count: num(c.NumOfCircuits) || 1, perCircuit: 0, busbar: 0 };
                        entry[key] += (c.Devices || []).reduce((t, d) => t + num(d.P_CalcResult), 0);
                        circuits.set(c.CircuitIndex, entry);
                    });
                    add(outDevices, 'perCircuit');
                    add(outConductors, 'perCircuit');
                    add(outBusbars, 'busbar');
                    circuits.forEach((c) => rows.push({ Id: 1, Definition: c.Definition, LostPower: c.perCircuit * c.count + c.busbar }));

                    list(manuel).forEach((e) => rows.push({ Id: 2, Definition: e.Explanation, LostPower: num(e.LostPower) }));

                    this.devicesdata = rows;
                    this.totalLostpower_3 = totals.total;
                }).catch(() => {
                    this.$buefy.dialog.alert(this.$errorModal({}));
                });
            },
            updateCalculationData(row) {
                if (row.Id == 3) {
                    this.openCalcBusbar();
                } else if (row.Id == 0) {
                    this.openInputCircuit();
                } else if (row.Id == 1) {
                    this.openOutputCircuit();
                } else if (row.Id == 2) {
                    this.openExtraPower();
                }
            },
            openCalcBusbar() {
                this.areHiddenStepsVisible = true;
                this.$store.state.areHiddenStepsVisible = this.areHiddenStepsVisible;
                this.$store.isPageOpenedFromStepBar = false;

                router.push('/calc_Busbar');
            },
            openInputCircuit() {
                this.areHiddenStepsVisible = true;
                this.$store.state.areHiddenStepsVisible = this.areHiddenStepsVisible;
                this.$store.isPageOpenedFromStepBar = false;

                router.push('/calc_InputCircuit');
            },
            openOutputCircuit() {
                this.areHiddenStepsVisible = true;
                this.$store.state.areHiddenStepsVisible = this.areHiddenStepsVisible;
                this.$store.isPageOpenedFromStepBar = false;

                router.push('/calc_OutputCircuit');
            },
            openExtraPower() {
                this.areHiddenStepsVisible = true;
                this.$store.state.areHiddenStepsVisible = this.areHiddenStepsVisible;
                this.$store.isPageOpenedFromStepBar = false;

                router.push('/calc_Manuel');
            },
            openCircuitDevices() {
                this.$store.state.isCircDevicesFromCalculation = true;
                router.push('/circuitDevices');
            },
            calculateLostPower_CurrentPanel() {
                if (this.isSecondTabActive && this.activeTab == 1) {
                    this.controlInputs();
                }
                var alfa = 0;
                if (this.$store.state.selectedIP_Id == 1) {
                    alfa = 3;
                } else {
                    alfa = 4.2;
                }
                this.totalLostpower_2 = alfa * this.$store.state.ae_value * (this.paneltemperature - this.envtemperature);
                this.totalLostpower_2 = parseFloat(this.totalLostpower_2);
                this.isLostPowerCalculated = true;
            },
            truncate(numToBeTruncated, numOfDecimals) {
                var theNumber = numToBeTruncated.toString();
                if (theNumber.includes('.')) {
                    var pointIndex = theNumber.indexOf('.');
                    var _result = +(theNumber.slice(0, pointIndex > -1 ? ++numOfDecimals + pointIndex : undefined));
                    var _resultString = _result.toString();
                    if (!_resultString.includes('.')) {
                        return _resultString + '.0';
                    } else {
                        return _result;
                    }
                } else {
                    return theNumber + '.0';
                }
            },
            columnTdAttrs(row, column) {
                if (row.id === 'Total') {
                    if (column.label === 'ID') {
                        return {
                            colspan: 4,
                            class: 'has-text-weight-bold',
                            style: {
                                'text-align': 'left !important'
                            }
                        }
                    } else if (column.label === 'Gender') {
                        return {
                            class: 'has-text-weight-semibold'
                        }
                    } else {
                        return {
                            style: { display: 'none' }
                        }
                    }
                }
                return null
            },
        },

    };
</script>
